'use strict';

angular.module('licensure.services')
    .factory('Trainings', ['$http', '$q', function ($http, $q) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/trainings', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/trainings/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            checkPrerequisites: function (courseid, userid) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/EducationModule/CourseAttendeeFailedPreReqs/' + courseid + '/' + userid, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            postCourseUserSummary: function (course) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/EducationModule/CourseUserSummary', course)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getForRegistration: function (args) {
                if (args == null) {
                    args = {};
                }
                args.forRegistration = true;
                return get(args);
            },

            save: function (training, license_request_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/trainings/';
                if (!isUndefined(training.id)) {
                    method = 'PUT'
                    url += training.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        training: training,
                        training_topics: training.training_topics,
                        license_request_id: license_request_id,
                        document_id: training.document_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            removeAttendeeFromCourse: function (id, attendees) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/EducationModule/BulkRemoveAttendees/' + id, attendees)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;